import { NavLink } from "react-router-dom";
import { Tooltip } from "@heroui/react";
import { PiWarningFill } from "react-icons/pi";
import { GiSandsOfTime } from "react-icons/gi";

interface WarningsCellContentProps {
  warnings: number;
  orderId: string;
  isActive: boolean;
  t: (key: string) => string;
}

export function WarningsCellContent({
  warnings,
  orderId,
  isActive,
  t,
}: Readonly<WarningsCellContentProps>) {
  const content =
    warnings === 0 ? (
      <GiSandsOfTime className="fill-vistawarningblue text-2xl" />
    ) : (
      <>
        <span>{warnings}</span>
        <PiWarningFill className="fill-vistactaorange text-2xl ml-1 pb-1" />
      </>
    );

  if (isActive) {
    return (
      <Tooltip content={t("processing_inprogress")}>
        <div className="text-bold text-small text-default-400 flex justify-center cursor-not-allowed">
          {content}
        </div>
      </Tooltip>
    );
  }

  return (
    <NavLink
      className="text-bold text-small text-default-500 flex justify-center"
      to={`/orders/${orderId}`}
    >
      {content}
    </NavLink>
  );
};

export default WarningsCellContent;
